import {
  GET_SCAN_ANALYSIS,
  GET_SCAN_ANALYSIS_SUCCESS,
  GET_SCAN_ANALYSIS_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getScanAnalysisReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCAN_ANALYSIS:
      return { ...state, loading: true };
    case GET_SCAN_ANALYSIS_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_SCAN_ANALYSIS_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getScanAnalysisReducer;
